<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <ul class="expensa-pages">
    <li v-for="page in pages" :key="page.id">
      <a
        :href="full(page)"
        target="_blank"
        rel="noopener noreferrer"
        class="expensa-page"
      >
        <img
          v-if="isImage(page) && page.thumbUrl"
          :src="thumb(page)"
          :alt="$t('expensa.page_alt') + ' ' + (page.pageIndex + 1)"
          loading="lazy"
        />
        <span v-else class="expensa-page-pdf">
          <svg
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M6 2h9l5 5v15H6z" />
            <path d="M15 2v5h5" />
          </svg>
          {{ isPdf(page) ? 'PDF' : $t('expensa.page_alt') }}
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
import {fileUrl} from '../util/api';

// Pagine di una spesa: miniatura che apre il file a dimensione piena in una
// nuova scheda; per i PDF (senza miniatura) un'icona.
export default {
  name: 'ExpensaPageViewer',
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    full(page) {
      return fileUrl(page.fileUrl);
    },
    thumb(page) {
      return fileUrl(page.thumbUrl);
    },
    isPdf(page) {
      return page.mime === 'application/pdf';
    },
    isImage(page) {
      return typeof page.mime === 'string' && page.mime.startsWith('image/');
    },
  },
};
</script>

<style scoped lang="scss">
.expensa-pages {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;
}
.expensa-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem;
  height: 10rem;
  border: 1px solid #e8eaef;
  border-radius: 0.5rem;
  overflow: hidden;
  color: #64728c;
  text-decoration: none;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
.expensa-page-pdf {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
}
</style>
